import React, { ComponentProps } from "react";

function HumanIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.39611 13.2401H14.6677C15.6292 13.2401 15.9622 12.9503 15.9622 12.4139C15.9622 10.9132 14.0582 8.84925 11.0319 8.84925C8.01043 8.84925 6.10645 10.9132 6.10645 12.4139C6.10645 12.9503 6.43939 13.2401 7.39611 13.2401ZM11.0367 7.81354C12.307 7.81354 13.385 6.6831 13.385 5.22171C13.385 3.78726 12.3001 2.69568 11.0367 2.69568C9.76847 2.69568 8.67771 3.80744 8.68353 5.23232C8.68562 6.6831 9.7616 7.81354 11.0367 7.81354Z"
        fill="white"
        fillOpacity={0.65}
      />
      <path
        d="M1.07595 13.2411H5.44754C4.8262 12.3488 5.50926 10.5829 6.82272 9.5569C6.17888 9.14203 5.34371 8.83278 4.29132 8.83278C1.68479 8.83278 0 10.7563 0 12.3415C0 12.9148 0.290015 13.2411 1.07595 13.2411ZM4.29132 7.94664C5.401 7.94664 6.33906 6.95725 6.33906 5.6894C6.33906 4.44056 5.39408 3.49002 4.29132 3.49002C3.19437 3.49002 2.23881 4.45969 2.24464 5.69897C2.2457 6.95725 3.18644 7.94664 4.29132 7.94664Z"
        fill="white"
        fillOpacity={0.65}
      />
    </svg>
  );
}

export default HumanIcon;
